<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height: unset" @click.stop>
                <div class="dialog-title" v-t="'message.title_setting_permit_ip_address'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small" style="height:530px;overflow-y:unset">
                    <!--- すべてのIPアドレスを許可 --->
                    <div style="padding-top:10px;padding-bottom:10px">
                        <el-radio v-model="permitType" label="0" @change="handleChangePermitType">
                            <span v-t="'message.item_all_ip_permitted'"/>
                        </el-radio>
                    </div>
                    <!--- 一部のIPアドレスを許可 --->
                    <div style="padding-top:10px;padding-bottom:10px">
                        <el-radio v-model="permitType" label="1" @change="handleChangePermitType">
                            <span v-t="'message.item_partial_ip_permitted'"/>
                        </el-radio>
                    </div>
                    <div style="padding-top:10px;padding-bottom:10px;padding-left:20px">
                        <span v-html="$t('message.desc_permit_ip_address')"></span>
                        <div style="padding-top:10px;padding-bottom:10px" v-t="'message.item_permitted_ip_address'"></div>
                        <!--- IPアドレスの追加 --->
                        <table width="100%">
                            <tr class="address-record-header">
                                <td class="address-item-title" v-t="'message.item_ip_address'"></td>
                                <td colspan="3" class="address-item-title" style="padding-left:37px" v-t="'message.item_comment'"></td>
                            </tr>
                            <tr class="ip-address-record2" style="border:none">
                                <!--- IPアドレス --->
                                <td class="receiver-item-value" style="padding-top: 10px;padding-bottom: 10px;padding-left:0px;width: 200px">
                                    <el-input size="large" type="text" placeholder="10.10.0.1/24" v-model="insertItem.definedIp" clearable>
                                    </el-input>
                                </td>
                                <!--- コメント --->
                                <td class="receiver-item-value" style="padding-top: 10px;padding-bottom: 10px;padding-left: 20px">
                                    <el-input size="large" style="width:600px" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="insertItem.description" clearable>
                                    </el-input>
                                </td>
                                <!--- 追加ボタン --->
                                <td colspan="2" class="receiver-item-command" style="width:115px;padding-right:15px;text-align:right">
                                    <button class="item-record-button" @click="endInputNewIpAddress(true)" type="button" style="width:unset"><span class="normal-command-text" v-t="'message.action_common_add'"></span></button>
                                </td>
                            </tr>
                        </table>
                        <!--- IPアドレスの編集 --->
                        <div style="height: 200px;border:none;overflow-y: auto">
                            <table v-if="showIpAddressList" width="100%">
                                <tr v-for="(ipAddress, index) in editPermitIpAddressList" :class="{ 'ip-address-record' : !ipAddress.editFlag, 'ip-address-record-no-border' : index==(editRecordIndex - 1)}">
                                    <!--- IPアドレス --->
                                    <td v-if="ipAddress.editFlag" width="185px" class="receiver-item-value" style="padding: 0px;width:200px">
                                        <el-input size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="editItem.definedIp" clearable>
                                        </el-input>
                                    </td>
                                    <td v-else class="receiver-item-value" style="width:185px;padding-left:16px">{{ ipAddress.definedIp }}</td>
                                    <!--- コメント --->
                                    <td v-if="ipAddress.editFlag" class="receiver-item-value" style="padding-top:0px;padding-left:20px">
                                        <el-input size="large" style="width:600px" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="editItem.description" clearable>
                                        </el-input>
                                    </td>
                                    <td v-else class="receiver-item-value" style="padding-left:35px">{{ ipAddress.description }}</td>
                                    <!--- 戻るボタン（編集中） --->
                                    <td v-if="ipAddress.editFlag" class="receiver-item-command">
                                        <button class="item-record-button" @click="closeEditIpAddressBox(ipAddress, false)" type="button"><span class="normal-command-text" v-t="'message.button_back'"></span></button>
                                    </td>
                                    <!--- 編集ボタン --->
                                    <td v-else class="receiver-item-command">
                                        <button class="item-record-button" @click="showEditIpAddress(ipAddress, index)" :disabled="itemEditing" type="button"><img src="../../../../assets/edit.svg"/></button>
                                    </td>
                                    <!--- 確認ボタン（編集中） --->
                                    <td v-if="ipAddress.editFlag" class="receiver-item-command" style="padding-top:0px;padding-bottom: 0px">
                                        <button class="item-record-button" @click="closeEditIpAddressBox(ipAddress, true)" type="button"><span class="normal-command-text" v-t="'message.button_confirm'"></span></button>
                                    </td>
                                    <!--- 削除ボタン --->
                                    <td v-else class="receiver-item-command">
                                        <button class="item-record-button" @click="removeIpAddress(index, ipAddress)" :disabled="itemEditing" type="button"><img src="../../../../assets/icon_delete_user.svg"/></button>
                                    </td>
                                </tr>
                             </table>
                        </div>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="saveCheck" :disabled="disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from '../../../charactercheck.js';
import commonUtil from '../../../commonutil.js';

export default {
    data() {
        return {
            showIpAddressList: true,
            editPermitIpAddressList: [],
            removeIpAddressList: [],
            permitType: null,
            insertItem: {
                definedIp: null,
                description: null
            },
            editItem: {
                definedIp: null,
                description: null
            },
            disableButton: true,
            itemEditing: false,
            editRecordIndex: -1,
            orgPermitType: null,
        };
    },
    methods: {
        startInputNewIpAddress() {
            this.insertItem.definedIp = null;
            this.insertItem.description = null;
            this.itemEditing = true;
            this.reDrawIpAddressList();
        },
        endInputNewIpAddress(saveFlag) {
            if (saveFlag) {
                if ((this.insertItem.definedIp == null) || (this.insertItem.definedIp == "")) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_not_specified"));
                    return;
                }
                if (this.editPermitIpAddressList.length >= 100 ) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_up_to_100"));
                    return;
                }
                if (this.insertItem.description != null) {
                    if (this.insertItem.description.length > 50 ) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_validate_permit_ip_address_comment"));
                        return;
                    }
                }
                let checkIp = commonUtil.changeAddressToNumeric(this.insertItem.definedIp);
                for (let ipAddress of this.editPermitIpAddressList) {
                    if (ipAddress.fromIp == checkIp) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_exist"));
                        return;
                    }
                }
                if (this.checkInputIpAddress(this.insertItem.definedIp)) {
                    this.editPermitIpAddressList.push({id: 0, definedIp: this.insertItem.definedIp, description: this.insertItem.description, editFlag: false, modified: false, fromIp: commonUtil.changeAddressToNumeric(this.insertItem.definedIp)});
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_invalid"));
                    return;
                }
            }
            this.sortIpAddressList();
            this.insertItem.definedIp = null;
            this.insertItem.description = null;
            this.disableButton = false;
            this.itemEditing = false;
            this.reDrawIpAddressList();
        },
        showEditIpAddress(ipAddress, index) {
            this.itemEditing = true;
            this.editRecordIndex = index;
            this.editItem.definedIp = ipAddress.definedIp;
            this.editItem.description = ipAddress.description;
            ipAddress.editFlag = true;
            this.reDrawIpAddressList();
        },
        closeEditIpAddressBox(ipAddress, saveFlag) {
            if (saveFlag) {
                if (this.checkInputIpAddress(this.editItem.definedIp)) {
                    let checkIp = commonUtil.changeAddressToNumeric(this.editItem.definedIp);
                    if (ipAddress.definedIp != this.editItem.definedIp) {
                        for (let ipAddress of this.editPermitIpAddressList) {
                            if (ipAddress.fromIp == checkIp) {
                                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_exist"));
                                return;
                            }
                        }
                    }
                    if (typeof ipAddress.orgDefinedIp === "undefined") {
                        ipAddress.orgDefinedIp = ipAddress.definedIp;
                    }
                    ipAddress.definedIp = this.editItem.definedIp;
                    ipAddress.description = this.editItem.description;
                    ipAddress.fromIp = commonUtil.changeAddressToNumeric(this.editItem.definedIp);
                    ipAddress.modified = true;
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_invalid"));
                    return;
                }
            }
            this.sortIpAddressList();
            ipAddress.editFlag = false;
            this.disableButton = false;
            this.itemEditing = false;
            this.editRecordIndex = -1;
            this.reDrawIpAddressList();
        },
        removeIpAddress(index, ipAddress) {
            if (ipAddress.id > 0) {
                this.removeIpAddressList.push({id: ipAddress.id, definedIp: ipAddress.definedIp});
            }
            this.editPermitIpAddressList.splice(index, 1);
            this.disableButton = false;
        },
        saveCheck() {
            if ((this.itemEditing) ||
                ((this.insertItem.definedIp != null) & (this.insertItem.definedIp != "")) ||
                ((this.insertItem.description != null) & (this.insertItem.description != ""))) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_cannot_save"));
                return;
            }
            if ((this.permitType == "1") & (this.editPermitIpAddressList.length == 0)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_ip_address_need_one_or_more"));
                return;
            }
            if ((this.permitType == "0") & (this.editPermitIpAddressList.length > 0)) {
                this.confirmPermittedAll()
            } else {
                this.save(false);
            }
        },
        save(forcedChange) {
            let addIpAddressList = [];
            let modifyIpAddressList = [];
            for (let ipAddress of this.editPermitIpAddressList) {
                if (ipAddress.id == 0) {
                    addIpAddressList.push({definedIp: ipAddress.definedIp, description: ipAddress.description});
                } else {
                    if (ipAddress.modified) {
                        modifyIpAddressList.push({id: ipAddress.id, definedIp: ipAddress.orgDefinedIp, newDefinedIp: ipAddress.definedIp, newDescription: ipAddress.description});
                    }
                }
            }
            let requestType = (this.orgPermitType == this.permitType) ? 1 : 0
            this.$emit('save', {addIpAddressList: addIpAddressList, modifyIpAddressList: modifyIpAddressList, removeIpAddressList: this.removeIpAddressList, requestType: requestType, forcedChange: forcedChange, permitType: this.permitType});
        },
        checkInputIpAddress(ipAddress) {
            let checkIpAddress = ipAddress.split("/");
            switch(checkIpAddress.length) {
                case 1:
                    break;
                case 2:
    	            if (!characterCheck.isValidForNumeric(checkIpAddress[1])) {
    	                return false;
                    }
                    let networkMask = Number(checkIpAddress[1]);
                    if ((networkMask <= 0) || (networkMask > 32)) {
                        return false;
                    }
	        	    break;
                default:
                    return false;
            }
            let hostAddress = checkIpAddress[0].split(".")
            if (hostAddress.length != 4) {
                return false;
            }
            for (let i = 0 ; i < hostAddress.length ; i++) {
                if (!characterCheck.isValidForNumeric(hostAddress[i])) {
                    return false;
                }
                let address = Number(hostAddress[i]);
                if ((address < 0) || (address > 254)) {
                    return false;
                }
            }
            return true;
        },
        sortIpAddressList() {
            this.editPermitIpAddressList.sort(function(a, b) {
                if (a.fromIp > b.fromIp) {
                    return 1;
                } else {
                    return -1;
                }
            })
        },
        confirmSaveProcess() {
            let self = this;
            this.$confirm(commonUtil.getMessageText(self.$i18n,"error_ip_address_out_of_range"), 'Warning', {
                confirmButtonText: commonUtil.getMessageText(self.$i18n,"button_save2"),
                cancelButtonText: commonUtil.getMessageText(self.$i18n,"button_cancel"),
                type: 'warning'
            }).then(() => {
                self.save(true);
            }).catch(() => {
                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_save_canceled"));
            });
        },
        confirmPermittedAll() {
            let self = this;
            this.$confirm(commonUtil.getMessageText(self.$i18n,"error_ip_address_permit_all"), 'Warning', {
                confirmButtonText: commonUtil.getMessageText(self.$i18n,"button_ok"),
                cancelButtonText: commonUtil.getMessageText(self.$i18n,"button_cancel"),
                type: 'warning'
            }).then(() => {
                self.save(false);
            }).catch(() => {
            });
        },
        handleChangePermitType() {
            this.disableButton = false;
        },
        reDrawIpAddressList() {
            this.showIpAddressList = false;
            this.$nextTick(() => {
                 this.showIpAddressList = true
            })
        },
    },
    created: function() {
        if (this.enablePermitIpOption) {
            this.permitType = "1";
        } else {
            this.permitType = "0";
        }
        this.orgPermitType = this.permitType;
        for (let permitIpAddress of this.permitIpAddressList) {
            this.editPermitIpAddressList.push({id: permitIpAddress.id, fromIp: permitIpAddress.fromIp, definedIp: permitIpAddress.definedIp, description: permitIpAddress.description, editFlag: false, modified: false});
        }
    },
    watch: {
    },
    mounted: function() {
    },
    props: ['enablePermitIpOption' , 'permitIpAddressList']
}
</script scoped>

<style scoped>
.address-record-header {
    width: 100%;
    background-color: #f6f6f6;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.address-item-title {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}

.ip-address-record {
    width: 100%;
    height: 40px;
    border-bottom:1px #eee solid;
}
.ip-address-record-no-border {
    width: 100%;
    height: 40px;
    border-bottom: none;
}
.ip-address-record:hover
{
    background-color: #ecf1fa;
}
.ip-address-record-header {
    width: 100%;
    background-color: #f6f6f6;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.receiver-item-value {
    vertical-align: top;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
    color: #848991;
}
.receiver-item-command {
    vertical-align: middle;
    width: 45px;
    color: #848991;
}
</style>
